import type { ComponentType } from '@grafikr/components';

import stringToNode from 'utils/string-to-node';

const Component: ComponentType = (node, { app }) => {
  const { url } = node.dataset;

  const getResponse = async () => {
    const response = await fetch(url);

    if (response.status >= 200 && response.status < 300) {
      return response.text();
    }

    throw new Error(`Could not fetch URL: "${url}". Server responded with: ${response.status}`);
  };

  const init = async () => {
    const { default: stringMemory } = await import(
      /* webpackChunkName: "string-memory" */ 'utils/string-memory'
    );
    const memory = stringMemory(sessionStorage);

    try {
      const response = await memory.get(`lazy-content-${url}`, getResponse);

      node.replaceWith(stringToNode(response));

      app.mount();
    } catch (e) {
      node.remove();

      throw e;
    }
  };

  init();
};

export default Component;
